import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Account from './pages/Account';
import BirthRecordUpdate from './pages/BirthRecordUpdate';
import Dashboard from './pages/Dashboard';
import EditProfile from './pages/EditProfile';
import Admin from './pages/Admin';
import SubscriptionRefundRequest from './pages/SubscriptionRefundRequest';
import ProSubscription from './pages/ProSubscription';
import AuthGuard from './AuthGuard';
import ProfileGuard from './ProfileGuard';
import AdminGuard from './AdminGuard';
import Error from './pages/Error';
import LegalPage from './pages/LegalPage';
import StripeCheckoutReturn from './pages/StripeCheckoutReturn';
import FreeNatalChart from './pages/FreeNatalChart';

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import './theme/variables.css';

setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/mapa-gratis" render={() => <FreeNatalChart />} />
        <Route
          exact
          path="/account/birth-record"
          render={() => (
            <AuthGuard>
              <ProfileGuard>
                <BirthRecordUpdate />
              </ProfileGuard>
            </AuthGuard>
          )}
        />
        <Route
          exact
          path="/account/subscription-refund"
          render={() => (
            <AuthGuard>
              <ProfileGuard>
                <SubscriptionRefundRequest />
              </ProfileGuard>
            </AuthGuard>
          )}
        />
        <Route
          exact
          path="/subscription/pro"
          render={() => (
            <AuthGuard>
              <ProfileGuard>
                <ProSubscription />
              </ProfileGuard>
            </AuthGuard>
          )}
        />
        <Route
          exact
          path="/checkout/stripe/success"
          render={() => <StripeCheckoutReturn outcome="success" />}
        />
        <Route
          exact
          path="/checkout/stripe/cancel"
          render={() => <StripeCheckoutReturn outcome="cancel" />}
        />
        <Route
          exact
          path="/account"
          render={() => (
            <AuthGuard>
              <ProfileGuard>
                <Account />
              </ProfileGuard>
            </AuthGuard>
          )}
        />
        <Route
          path="/edit-profile"
          render={() => (
            <AuthGuard>
              <ProfileGuard>
                <EditProfile />
              </ProfileGuard>
            </AuthGuard>
          )}
        />
        <Route
          path="/dashboard"
          render={() => (
            <AuthGuard>
              <ProfileGuard>
                <Dashboard />
              </ProfileGuard>
            </AuthGuard>
          )}
        />
        <Route
          exact
          path="/admin"
          render={() => (
            <AuthGuard>
              <AdminGuard>
                <Admin />
              </AdminGuard>
            </AuthGuard>
          )}
        />
        <Route exact path="/legal/:slug" render={() => <LegalPage />} />
        <Route exact path="/error" render={() => <Error />} />
        <Route exact path="/signin-oidc" render={() => <Redirect to="/dashboard" />} />
        <Route exact path="/signout-callback-oidc" render={() => <Redirect to="/" />} />
        <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
